function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rectangle\u5907\u4EFD@1x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5207\\u56FE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u5236\\u4F5C-\\u97F3\\u9891\\u5236\\u4F5C-\\u5168\\u90E8\\u5185\\u5BB9",
  transform: "translate(-942.000000, -505.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-19",
  transform: "translate(942.000000, 505.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-17"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle\\u5907\\u4EFD",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-16",
  transform: "translate(3.000000, 4.000000)",
  fill: "#000000",
  fillOpacity: 0.45
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.68344316,12.1179305 C6.53234113,12.1320182 6.29239567,12.1148441 6.14708778,11.9695362 C6.14708778,11.9695362 2.59020677,8.63362773 2.43910475,8.48523343 L1.2439029,8.48523343 C0.574566386,8.48523343 4.79616347e-14,7.94262947 4.79616347e-14,7.27338763 L4.79616347e-14,4.84969605 C4.79616347e-14,4.18041634 0.574604257,3.63785026 1.24386503,3.63785026 L2.43991896,3.63785026 C2.59102098,3.4878086 6.14790199,0.153509575 6.14790199,0.153509575 C6.30538514,-0.00397357263 6.53315534,-0.00897243652 6.68425737,0.00511527082 C6.99146027,0.0341238295 7.27105582,0.32615973 7.27105582,0.562204569 C7.27355525,0.588713695 7.27522154,11.53348 7.27105582,11.5600081 C7.27107476,11.7905618 6.98981292,12.0888841 6.68344316,12.1179305 L6.68344316,12.1179305 Z",
  id: "Path",
  transform: "translate(3.636797, 6.060968) scale(1, -1) translate(-3.636797, -6.060968) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.17573593,4.17573593 C9.41005051,3.94142136 9.78994949,3.94142136 10.0242641,4.17573593 L10.0242641,4.17573593 L11.297,5.448 L12.5698485,4.17573593 C12.8041631,3.94142136 13.184062,3.94142136 13.4183766,4.17573593 C13.6526912,4.41005051 13.6526912,4.78994949 13.4183766,5.02426407 L12.146,6.297 L13.4183766,7.56984848 C13.6266562,7.7781281 13.6497984,8.10143738 13.4878032,8.33527915 L13.4183766,8.41837662 C13.184062,8.65269119 12.8041631,8.65269119 12.5698485,8.41837662 L12.5698485,8.41837662 L11.297,7.146 L10.0242641,8.41837662 C9.78994949,8.65269119 9.41005051,8.65269119 9.17573593,8.41837662 C8.94142136,8.18406204 8.94142136,7.80416306 9.17573593,7.56984848 L10.448,6.297 L9.17573593,5.02426407 C8.96745631,4.81598445 8.94431413,4.49267517 9.10630939,4.2588334 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408"
}))))));

var SvgVolumeLow = function SvgVolumeLow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolumeLow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume_low.ac5276d3.svg";
export { ForwardRef as ReactComponent };